// @ts-nocheck
import { BlockBorderProps } from "@store/Components/Toolkit/Block";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";

export const defaultBorderProps: BlockBorderProps = {
    width: pxToRem(1),
    type: "solid",
    color: "common.border",
};
